import {Colors, IconMenuItem} from "@bounce/shared/ui";
import {IconMenuItemProps} from "@bounce/shared/ui/components/IconMenuItem";
import {ReactNode} from "react";

interface Props {
  label: IconMenuItemProps["label"];
  value?: string;
  icon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  hasHover?: boolean;
}

const CustomMenuItem = ({label, value, icon, onClick, disabled = false, hasHover = true}: Props) => {
  const iconMenuItemStyles = {
    menuItem: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      padding: "8px",
      minHeight: "0",
      borderRadius: "8px",
      "&:hover, &:active": {
        background: hasHover ? Colors.primary._100 : "transparent",
      },
      color: Colors.primary._800,
    },
  };

  return (
    <IconMenuItem
      label={label}
      value={value}
      icon={icon}
      onClick={onClick}
      sx={iconMenuItemStyles.menuItem}
      divider={false}
      disabled={disabled}
      fontWeight="medium"
      color={Colors.primary._800}
    />
  );
};

export default CustomMenuItem;
